import { useState } from 'react';
/**
 * This hook will cache old versions of table data while the
 * new data is loading.
 * This is because when we are changing pages/sorting/filtering,
 * we want to ensure the user doesn't see a blank table while
 * the data is loading.
 * Note for consumers: If loading takes a long time, (>400ms)
 * you should have a debounce set on `isLoading` to show a
 * loading spinner.
 */
export function useDataTableCache({
  data,
  isLoading
}) {
  const [dataCache, setDataCache] = useState(data);
  if (dataCache !== data && !isLoading) {
    setDataCache(data);
  }
  return dataCache;
}